export default __webpack_public_path__ + "static/media/custom-paket-mk.06d6a761.png";